import React from "react";
import { useNavigate } from "react-router-dom";
import "./ServiceGrid.css";

const services = [
  {
    title: "Household Junk",
    description: "Professional removal of old furniture, appliances, electronics, and general household clutter with eco-friendly disposal.",
    icon: (
      <svg className="service-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 6H5H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    color: "#6AB7FF",
    link: "/services/household-junk"
  },
  {
    title: "Yard Debris Removal",
    description: "Efficient clearing of yard waste including branches, leaves, grass clippings, and other organic debris with proper disposal methods.",
    icon: (
      <svg className="service-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L4 10H10V22H14V10H20L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    color: "#FF9E6A",
    link: "/services/YardDebrisRemoval"
  },
  {
    title: "Garage Cleanouts",
    description: "Complete garage organization and removal of unwanted items, tools, equipment, and years of accumulated storage.",
    icon: (
      <svg className="service-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 22H18C19.1046 22 20 21.1046 20 20V12C20 10.8954 19.1046 10 18 10H6C4.89543 10 4 10.8954 4 12V20C4 21.1046 4.89543 22 6 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6 10V6C6 4.89543 6.89543 4 8 4H16C17.1046 4 18 4.89543 18 6V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8 16H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    color: "#8AFF6A",
    link: "/services/garage-cleanouts"
  },
  {
    title: "Construction Debris",
    description: "Quick and safe disposal of construction waste, renovation debris, drywall, lumber, and other building materials.",
    icon: (
      <svg className="service-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 21H3V13H11V21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13 11H21V19H13V11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M19 8V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    color: "#FF6A9E",
    link: "/services/construction-debris"
  },
  {
    title: "Foreclosures & Evictions",
    description: "Comprehensive cleanout services for properties undergoing foreclosure or eviction with fast turnaround times.",
    icon: (
      <svg className="service-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9 22V12H15V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    color: "#9E6AFF",
    link: "/services/Foreclosures&Evictions"
  },
  {
    title: "Donation Pickups",
    description: "Convenient pickup of items for donation with proper handling and delivery to local charity organizations.",
    icon: (
      <svg className="service-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 8V4C16 2.89543 15.1046 2 14 2H10C8.89543 2 8 2.89543 8 4V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M20 8H4C2.89543 8 2 8.89543 2 10V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V10C22 8.89543 21.1046 8 20 8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 15V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    color: "#6AFFB7",
    link: "/services/Donationpickups"
  },
  {
    title: "Junk Removal",
    description: "Specialized removal of construction materials, concrete, roofing, and other heavy debris from job sites.",
    icon: (
      <svg className="service-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 10V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14 10V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5 6H19L18 22H6L5 6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9 6V4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    color: "#FFB76A",
    link: "/services/Junkremoval"
  }
];

export default function ServiceGrid() {
  const navigate = useNavigate();

  const handleCardClick = (link) => {
    navigate(link);
  };

  const handleButtonClick = (link, e) => {
    e.stopPropagation();
    navigate(link);
  };

  // Split services into two arrays: first 4 and last 3
  const firstRowServices = services.slice(0, 4);
  const secondRowServices = services.slice(4);

  return (
    <section className="service-grid-section">
      <div className="service-grid-container">
        <h2 className="service-grid-heading">
          <span className="heading-accent">Our Junk</span>  Removal Services
        </h2>
        <p className="service-grid-subheading">
          Eco-friendly solutions for all your junk removal needs
        </p>
        
        {/* First row with 4 cards */}
        <div className="service-grid service-grid-first-row">
          {firstRowServices.map((service, index) => (
            <div 
              key={index} 
              className="service-card"
              style={{ "--card-accent": service.color }}
              onClick={() => handleCardClick(service.link)}
            >
              <div className="card-icon-container">
                {service.icon}
              </div>
              <h3 
                className="card-title"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCardClick(service.link);
                }}
              >
                {service.title}
              </h3>
              <p className="card-description">{service.description}</p>
              <button 
                className="card-button"
                onClick={(e) => handleButtonClick(service.link, e)}
              >
                Explore Service
                <span className="button-arrow">→</span>
              </button>
            </div>
          ))}
        </div>
        
        {/* Second row with 3 cards centered */}
        <div className="service-grid service-grid-second-row">
          {secondRowServices.map((service, index) => (
            <div 
              key={index} 
              className="service-card"
              style={{ "--card-accent": service.color }}
              onClick={() => handleCardClick(service.link)}
            >
              <div className="card-icon-container">
                {service.icon}
              </div>
              <h3 
                className="card-title"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCardClick(service.link);
                }}
              >
                {service.title}
              </h3>
              <p className="card-description">{service.description}</p>
              <button 
                className="card-button"
                onClick={(e) => handleButtonClick(service.link, e)}
              >
                Explore Service
                <span className="button-arrow">→</span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}